<template>
  <div id="app">
    <router-view></router-view>
    <AppFooter v-if="!route.meta.hideFooter" />
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import AppFooter from './components/AppFooter.vue';

const route = useRoute();
</script>

<style>
#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
